import { TemplatePage } from './types';

const liveStreamSubtleTheme: TemplatePage = {
  header: {
    color: '#DFDFE9',
    icon: 'images/video-templates/subtle_theme.jpg',
    title: 'Live Stream Templates — Subtle Black & White Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Subtle B/W Theme',
    description_meta:
      'Make stunning designs for live streams with Wave.video’s subtle b/w package of templates. ' +
      'The set contains free and customizable transition screens and overlays. ',
    description:
      'Impress your live streams’ viewers using our pack of subtle black & white templates. ' +
      'Get a perfect set of pre-designed overlays, transition screens, and frames for multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.` +
      ' Take your live shows to the next level.'
  },
  footer: {
    category: 'Live streaming subtle theme',
    description:
      'With Wave.video’s themed collections of editable overlay and transition screen templates for ' +
      'live streams, you will make your live stream look more professional with no design background. ' +
      'Pick a template that you like and replace any elements to match your brand and style perfectly. ' +
      'We recommend starting with a set containing countdown, intro, be right back screen, and lower ' +
      'thirds that introduce your speakers.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming subtle theme',
      search: { name: 'SubtleBWTheme', tags: 'SubtleBWTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamSubtleTheme;
